import {
  useCallback,
  useEffect,
  useState,
  // useState
} from "react";
import { FetchPrivacyPolicy } from "../../helpers/api_helpers";
import "./nofound.css";
// Redux actions

// Components
import PageBanner from "../components/layout/pages/PageBanner";
import { Outlet } from "react-router";
import Navbar from "../../views/components/layout/common/Navbar";
import Footer from "../../views/components/layout/common/Footer";
let imgBaseUrl = process.env.REACT_APP_API_IMG_URL;

const NotFound = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchPrivacyPolicy();
  }, []);
  const fetchPrivacyPolicy = async () => {
    try {
      setIsLoading(true);
      let response = await FetchPrivacyPolicy({
        urlPath: "fair-use-policy?populate=deep",
        method: "GET",
      });

      if (!response) {
        throw new Error("Failed to fetch privacy policy");
      }

      setPrivacyPolicy(response);
    } catch (err: any) {
      setError(err.message);
      console.error("Error fetching privacy policy:", err);
    } finally {
      setIsLoading(false);
    }
  };
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!privacyPolicy?.data?.attributes) return <div>No data available</div>;
  return (
    <>
      {/* page banner area start */}

      <div id="oopss">
        <div id="error-text">
          <img src="https://cdn.rawgit.com/ahmedhosna95/upload/1731955f/sad404.svg" alt="404" />
          <span>404 PAGE</span>
          <p className="p-a">. The page you were looking for could not be found</p>

          <a href="/" className="back">
            ... Back to Home page
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
